import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_TAB](state, p) {
    const drp = p.drp;
    drp.tabs.push(p.newTab);
  },
  [types.REMOVE_TAB](state, p) {
    const drp = p.drp;
    drp.tabs.splice(p.tabIndex, 1);
  },
  [types.SET_TAB_TITLE](state, p) {
    p.tab.title = p.title;
  },
  [types.SET_TAB_LAYOUT](state, p) {
    const drp = p.drp;
    drp.layout = p.layout;
    drp.tabClassList = [`drzTabs-tab-${p.layout}`];
    drp.menuClassList = [];
    drp.contentClassList = [];
    if (p.layout === 'left') {
      drp.menuClassList = [`drzTabs-menu-${p.layout}`];
      drp.contentClassList = [`drzTabs-content-${p.layout}`];
    }
  },
};

const actions = {
  addNewTab: ({ commit }, payload) => {
    commit(types.ADD_TAB, payload);
  },
  removeTab: ({ commit }, payload) => {
    commit(types.REMOVE_TAB, payload);
  },
  async setTabTitle({ dispatch, commit }, payload) {
    await commit(types.SET_TAB_TITLE, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
  setTabLayout: ({ commit }, payload) => {
    commit(types.SET_TAB_LAYOUT, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/tabs/vuex.js